import * as url from "../url_helper";

import { post } from "../api_helper";

export const addTemplate = data => post(url.ADD_TEMPLATE, data);

export const getTemplate = data => post(url.GET_TEMPLATE, data);

export const editTemplate = data => post(url.EDIT_TEMPLATE, data);

export const getEmailTemplate = data => post(url.GET_EMAIL_TEMPLATE, data);
